import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography, alpha, useTheme } from '@mui/material';

interface AuthSuccessPanelProps {
  icon: React.ReactNode;
  title: string;
  message: string;
  actionLabel: string;
  actionTo?: string;
}

const AuthSuccessPanel: React.FC<AuthSuccessPanelProps> = ({
  icon,
  title,
  message,
  actionLabel,
  actionTo = '/login',
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        textAlign: 'center',
        px: { xs: 1, sm: 2 },
        py: 3,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2.5,
          bgcolor: alpha(theme.palette.success.main, 0.12),
          color: 'success.main',
        }}
      >
        {icon}
      </Box>

      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, lineHeight: 1.6, maxWidth: 320, mx: 'auto' }}
      >
        {message}
      </Typography>

      <Button
        component={RouterLink}
        to={actionTo}
        variant="contained"
        size="large"
        fullWidth
        sx={{
          py: 1.5,
          borderRadius: 1,
          fontSize: 16,
          boxShadow: `0 8px 24px ${alpha(theme.palette.primary.main, 0.28)}`,
          '&:hover': {
            boxShadow: `0 10px 28px ${alpha(theme.palette.primary.main, 0.34)}`,
          },
        }}
      >
        {actionLabel}
      </Button>
    </Box>
  );
};

export default AuthSuccessPanel;
